import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { Link, Switch } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";

import { ContentRoute } from "../../../../_metronic/layout";
import { CategoryList } from "../../../Pages/Client/Category";
import { GET_CATEGORIES } from "../../Categories/Graphql/query";
import * as auth from "../_redux/authRedux";

import { ErrorPage1 } from "./../../../Modules/ErrorsExamples/ErrorPage1";

export const Dashboard = ({ history, location }) => {
  const [categoriesList, setCategoriesList] = useState([]);

  const [userDetail, setUserDetail] = useState(null);

  const dispatch = useDispatch();

  const [
    { loading: categoriesLoading, error: categoriesError, data: categoriesData },
  ] = useLazyQuery(GET_CATEGORIES, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (categoriesData) {
      const data = categoriesData.listCategoriesByPriority;

      if (data && Array.isArray(data)) {
        setCategoriesList(data);
      }
    }
  }, [categoriesData, categoriesError, categoriesLoading]);

  return (
    <>
      <div>
        <div
          className="modal_style_custom_header form-group row"
          style={{ backgroundColor: "#232628", padding: 10 }}
        >
          <h4 style={{ color: "#fcb24a", fontWeight: "700", fontSize: 24 }}>
            equipbid
          </h4>
          {userDetail ? (
            <>
              <p
                style={{ color: "white", textIndent: "5px", marginTop: "4px" }}
              >
                Welcome {userDetail.firstName},{" "}
              </p>
              <Link
                to="/logout"
                className="font-weight-bold ml-3"
                id="kt_login_forgot"
              >
                Logout
              </Link>
            </>
          ) : (
            <Link
              to="/auth/login"
              className="font-weight-bold ml-3"
              id="kt_login_forgot"
            >
              Login/Register
            </Link>
          )}
        </div>
        <Switch>
          <ContentRoute exact path="/auth/dashboard" component={CategoryList} />
          <ContentRoute component={ErrorPage1} />
        </Switch>
      </div>
    </>
  );
};

export default injectIntl(connect(null, auth.actions)(Dashboard));
